/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645464364414,
	"notificationDetails": {"updateType":"TRADE_PLAN_PNL_UPDATE","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TRADE_PLAN_PNL_UPDATE",
	"statusDetails": {"positionPnl":25.2,"planPnl":25.4},
	"date": "2022-02-21T12:26:05.306-0500",
	"timestamp": "1645464365306"
}
 * @param {*} statusDetails 
 * @returns an object with fields:
 * 1) positionPnl: how much pnl did the most recent trade make
 * 2) planPnl: how much has the plan made so far if repeating tradeplan
 */
export function tradePlanPnlUpdateParser(statusDetails) {
  const parsedObj = {
    positionPnl: null,
    planPnl: null,
  };
  if (statusDetails) {
    parsedObj.positionPnl = statusDetails.positionPnl ?? null;
    parsedObj.planPnl = statusDetails.planPnl ?? null;
  }

  return parsedObj;
}
